// glocal
import React from 'react';
import ReactDOM from 'react-dom';
// import the semantic UI CSS
import 'semantic-ui-css/semantic.min.css';
// import base components
import Root from './app/Root';
// render the root component
ReactDOM.render(<Root />, document.getElementById('root'));
